export enum StaffReviewStatusEnum {
  Reviewed = 'reviewed',
  Awaiting = 'awaiting',
  Reviewing = 'reviewing',
}

export interface ReviewedAnswer {
  answerId: string;
  reviewStatus: boolean;
  reviewDate: Date;
  user: string;
}

export type SyncFormPayload = {
  staffReviewStatus: StaffReviewStatusEnum;
  reviewedAnswers: ReviewedAnswer[];
};
